<template>
  <div>
    <b-card class="p-0 mb-1" no-body>
      <b-nav class="navbar d-flex justify-content-between bd-highlight flex-wrap">
        <div class="d-flex">
          <b-form-radio @change="statusChang(statusValue)" v-model="statusValue" value="open" class="custom-control-danger"> เเจ้ง </b-form-radio>
          <b-form-radio @change="statusChang(statusValue)" v-model="statusValue" value="in progress" class="custom-control-info"> ดำเนินการ </b-form-radio>
          <b-form-radio @change="statusChang(statusValue)" v-model="statusValue" value="resolved" class="custom-control-success"> เสร็จเเล้ว </b-form-radio>
        </div>
        <div class="bd-highlight">
          <b-button
            variant="success"
            @click="
              () => {
                this.$router.push({ name: 'fromticket' });
                this.$store.dispatch('addChang', this.typeName);
              }
            "
          >
            เพิ่ม
          </b-button>
        </div>
      </b-nav>
    </b-card>

    <b-alert :show="isNodata" class="w-50 w-100" variant="danger">
      <div class="alert-body text-center">
        <feather-icon icon="InfoIcon" class="mr-50" />
        <span>ไม่มีข้อมูล</span>
      </div>
    </b-alert>
    <div class="row">
      <div v-for="(item, index) in items" :key="index" class="col-12 col-md-6 col-lg-4">
        <b-overlay :show="playLoad" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
          <div class="card">
            <div class="item-img" v-if="item.urlImage.length">
              <swiper :options="swiperOptions" class="swiper-lazy-loading">
                <swiper-slide v-for="(image, index) in item.urlImage" :key="index">
                  <b-img :src="image" fluid center class="swiper-lazy card-img-top mw-100" style="max-width: 100%; height: 300px; object-fit: cover" />
                  <div v-if="index != 0">
                    <div class="swiper-lazy-preloader swiper-lazy-preloader-white" />
                  </div>
                </swiper-slide>
                <div slot="pagination" class="swiper-pagination" />
                <div slot="button-next" class="swiper-button-next swiper-button-white" />
                <div slot="button-prev" class="swiper-button-prev swiper-button-white" />
              </swiper>
            </div>
            <div v-else>
              <div class="item-img" style="max-width: 100%; height: 300px; object-fit: cover">
                <b-overlay :show="true" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm" no-wrap />
              </div>
            </div>

            <div class="card-body">
              <span class="card-text">
                <span v-if="item.status === 'open'">
                  <b-badge variant="danger">
                    <span class="h5 text-white">เเจ้ง</span>
                  </b-badge>
                </span>
                <span v-else-if="item.status === 'in progress'">
                  <b-badge variant="info">
                    <span class="h5 text-white">ดำเนินการ</span>
                  </b-badge>
                </span>
                <span v-else-if="item.status === 'resolved'">
                  <b-badge variant="success">
                    <span class="h5 text-white">เสร็จเเล้ว</span>
                  </b-badge>
                </span>
                {{ item.title }}
              </span>
            </div>

            <div class="list-group list-group-flush">
              <div class="list-group-item">
                <b-link
                  class="col-12 col-sm-6 col-lg-3"
                  @click="
                    () => {
                      $store.dispatch('addStates', item);
                      $router.push({ name: 'mapsingle' });
                    }
                  "
                >
                  <a><feather-icon icon="MapPinIcon" class="mr-25" />GPS</a>
                </b-link>
              </div>
            </div>
            <hr class="p-0 m-0" />
            <div class="row col-12">
              <!-- <div class="col-6 text-center">
                <b-button @click="() => {}" variant="flat-warning" squared block> แก้ไข </b-button>
              </div> -->

              <div class="col-6">
                <b-button @click="deleteItems(item)" variant="flat-danger" squared block> ลบ </b-button>
              </div>
              <div class="col-6">
                <b-button
                  @click="
                    () => {
                      $router.push({ name: 'detall_ticket', params: { type: item.type, name: item.title, ticketId: item.ticketId } });
                      $store.dispatch('addStates', item);
                    }
                  "
                  variant="flat-warning"
                  class="btn-icon"
                  squared
                  block
                >
                  ติดตามสถานะ
                </b-button>
              </div>
            </div>
            <div class="card-footer d-flex justify-content-between flex-wrap">
              <div class="flex-wrap">
                <small class="text-muted">
                  Create: <cite>{{ formatToThaiTime(item.registerDate) }}</cite>
                </small>
              </div>
              <div class="flex-wrap">
                <small class="text-muted">
                  Update: <cite>{{ formatTofromNow(item.registerDate) }}</cite>
                </small>
              </div>
            </div>
          </div>
        </b-overlay>
      </div>
    </div>
    <b-card v-show="false" class="p-0 mb-1" no-body>
      <b-nav class="navbar d-flex justify-content-between bd-highlight flex-wrap">
        <div>Showing {{ currentPage }} to {{ perPage }} of {{ totalPage }} entries</div>
        <div class="bd-highlight">
          <b-pagination v-model="currentPage" :total-rows="totalPage" :per-page="perPage" @input="handlePageChange" class="mb-0" first-text="First" prev-text="Prev" next-text="Next" align="left" last-text="Last" hide-goto-end-buttons />
        </div>
      </b-nav>
    </b-card>
  </div>
</template>

<script>
  import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
  import 'swiper/css/swiper.css';
  import dayjs from 'dayjs';
  import 'dayjs/locale/th';
  import utc from 'dayjs/plugin/utc';
  import timezone from 'dayjs/plugin/timezone';
  import axios from 'axios';
  import API from '@/connect/config';
  dayjs.extend(utc);
  dayjs.extend(timezone);
  const buddhistEra = require('dayjs/plugin/buddhistEra');

  dayjs.extend(buddhistEra);
  const relativeTime = require('dayjs/plugin/relativeTime');
  dayjs.extend(relativeTime);

  export default {
    components: {
      Swiper,
      SwiperSlide,
    },
    data() {
      return {
        statusValue: [], //'open', 'in progress', 'resolved'
        // status: [{ value: null, text: 'เลือกประเภท' }],
        typeName: 'appeal',
        currentPage: 1, // จำนวนรายการที่แสดงในแต่ละหน้า
        perPage: 6, // จำนวนรายการที่แสดงในแต่ละหน้า
        totalPage: 0, // จำนวนรายการ
        playLoad: true,
        isNodata: false,
        items: [],
        searchItems: '',

        swiperOptions: {
          lazy: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        },
      };
    },

    created() {
      this.getDataTable();
    },
    methods: {
      async deleteItems(value) {
        this.$swal({
          title: 'ลบข้อมูล?',
          text: 'คุณต้องการจะลบข้อมูล ใช่หรือไม่!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'ลบ',
          cancelButtonText: 'ยกเลิก',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(async (result) => {
          if (result.value) {
            // console.log(value);
            const { userId } = JSON.parse(localStorage.getItem('company_jwt_vis'));
            const { ticketId } = value;
            const data = {
              userId: userId,
              ticketId: ticketId,
            };

            await axios
              .delete(`${API}ticket`, { data: data })
              .then(async (el) => {
                if (el.data.message == 'delete completed') {
                  this.$swal({
                    icon: 'success',
                    title: 'ลบข้อมูล!',
                    text: 'ลบข้อมูลสำเร็จ',
                    showCancelButton: false,
                    showConfirmButton: false,
                    timer: 1500,
                    customClass: {
                      confirmButton: 'btn btn-success',
                    },
                  });
                }
                this.getDataTable();
              })
              .catch((err) => {
                console.log(err);
              });

            return;
          }
        });
      },
      statusChang(value) {
        this.statusValue = value;
        this.getDataTable();
      },

      showmore() {
        this.currentPage += 1;
        this.getDataTable();
      },
      handlePageChange(page) {
        this.currentPage = page;
        this.items = [];
        this.getDataTable();
      },
      handleItemsPerPageChange() {
        // กรณีที่ต้องการให้เลือกจำนวนรายการที่แสดงเปลี่ยนแปลงทันที
        this.currentPage = 1;
        this.items = [];
        this.getDataTable();
      },

      formatTofromNow(date) {
        // เวลาที่อัพเดท
        return dayjs().locale('th').to(date);
      },
      formatToThaiTime(date) {
        // เปลี่ยนวันที่ไทย
        return dayjs.tz(date, 'Asia/Bangkok').locale('th').format('DD-MMM-BBBB');
      },

      async getDataTable() {
        const { userId, uId } = JSON.parse(localStorage.getItem('company_jwt_vis'));
        this.$store
          .dispatch('getAll', `${API}ticket/${userId}?uId=${uId}&type=${this.typeName}&status=${this.statusValue}`)
          .then(async (res) => {
            const tickets = res;
            tickets.sort((a, b) => (a.registerDate < b.registerDate ? 1 : a.registerDate > b.registerDate ? -1 : 0));
            await tickets.forEach(async (el) => {
              const image = [];
              this.$store.dispatch('getAll', `${API}chat/${userId}?ticketId=${el.ticketId}`).then(async (res) => {
                const chats = res;
                if (chats.length != 0) {
                  chats.forEach(async (res) => {
                    if (res.description == 'txt_msg_description' && res.uId === uId) {
                      image.push(await this.$store.dispatch('getImageURL', res.chatImage).then((res) => res));
                    }
                  });
                } else {
                  image.push('https://th.bing.com/th/id/OIP.MvgjeMBHxcKil9_H4jQcvgAAAA?rs=1&pid=ImgDetMain');
                }
              });

              el.urlImage = image;
            });
            tickets.sort((a, b) => (a.registerDate < b.registerDate ? 1 : a.registerDate > b.registerDate ? -1 : 0));
            this.items = tickets;
            this.totalPage = res.length;
            this.playLoad = false;
            this.isNodata = this.items.length == 0 ? true : false;
          })
          .catch((error) => {
            console.error('Error fetching data:', error);
          });
      },
    },
  };
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/swiper.scss';
  .item-description {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
</style>
